import React, { useState } from "react";
import { RootState } from "../../../../../store/store";
import { useSelector } from "react-redux";
import { transformAmount } from "../../../../../utils/helper";
import { EditOutlined } from "@ant-design/icons";
import Updateusername from "../../../../../components/dashboardpages/updateusername/updateusername";

const Teacherprofilemain = () => {
  const [showUpdateUsername, setShowUpdateUsername] = useState(false);

  const state = useSelector((state: RootState) => ({
    user: state.user.user,
  }));

  const { user } = state;

  const closeUpdateUsername = () => {
    setShowUpdateUsername(false);
  };

  return (
    <div className="h-screen">
      <div className="custom-primary-bg-two relative rounded-[30px] p-4">
        <div className="flex">
          <div className="relative h-[6.6rem] w-[6rem]">
            <img
              src={
                user?.photoURL === ""
                  ? "/img/vectors/userfemale.svg"
                  : user?.photoURL
              }
              alt="profileimage"
              className="h-full w-full rounded-[25px]"
            />
            <div className="custom-primary-bg-two absolute right-[0.3rem] top-[0.3rem] w-fit cursor-pointer rounded-full px-[0.4rem] py-[0.1rem] pb-[0.3rem]">
              <EditOutlined className="text-appcolorwhite" />
            </div>
          </div>

          <div className="ml-2">
            <p className="text-base text-appcolorwhite">{user?.firstName}</p>
            <p className="mb-2 text-base text-appcolorwhite opacity-[0.7]">
              {user?.lastName}
            </p>

            <div className="custom-white-bg-faint-bg flex items-center justify-between rounded-[25px] px-[0.7rem] py-[0.3rem]">
              <span className="text-appcolorwhite">{user?.userName}</span>

              <EditOutlined
                className="pl-4 cursor-pointer text-appcolorwhite"
                onClick={() => {
                  setShowUpdateUsername(true);
                }}
              />
            </div>

            <div className="flex mt-2">
              <div className="custom-white-bg-faint-bg mr-2 flex items-center justify-between rounded-[25px] px-[0.7rem] py-[0.3rem]">
                <div className="mr-[0.4rem]">
                  <img
                    src="/img/vectors/key.svg"
                    alt="key"
                    className="h-[0.8rem] w-[0.8rem]"
                  />
                </div>
                <span className="ml-2 text-appcolorwhite">
                  {transformAmount(user?.wallet?.funKeys || 0)}
                </span>
              </div>

              <div className="custom-white-bg-faint-bg flex items-center justify-between rounded-[25px] px-[0.7rem] py-[0.3rem]">
                <div className="mr-[0.4rem]">
                  <img
                    src="/img/vectors/star.svg"
                    alt="star"
                    className="h-[0.8rem] w-[0.8rem]"
                  />
                </div>
                <span className="ml-2 text-appcolorwhite">
                  {transformAmount(user?.wallet?.funPoints || 0)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showUpdateUsername ? (
        <Updateusername
          open={showUpdateUsername}
          closeModal={closeUpdateUsername}
        />
      ) : null}
    </div>
  );
};

export default Teacherprofilemain;
